/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/fragments-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/fragments-api-client";
import type { CfrTranscodingStartCfrTranscodingJobMutationRequest, CfrTranscodingStartCfrTranscodingJobMutationResponse, CfrTranscodingStartCfrTranscodingJobPathParams } from "../models/CfrTranscodingStartCfrTranscodingJob";
import type { UseMutationOptions, QueryClient } from "@tanstack/react-query";
import { cfrTranscodingStartCfrTranscodingJob } from "../axios/cfrTranscodingStartCfrTranscodingJob";
import { useMutation } from "@tanstack/react-query";

export const cfrTranscodingStartCfrTranscodingJobMutationKey = () => ["fragments-api", { url: '/cfr-transcoding/:fragmentId/start' }] as const

export type CfrTranscodingStartCfrTranscodingJobMutationKey = ReturnType<typeof cfrTranscodingStartCfrTranscodingJobMutationKey>

/**
 * @summary Start CFR transcoding job for a fragment
 * {@link /cfr-transcoding/:fragmentId/start}
 */
export function useCfrTranscodingStartCfrTranscodingJob<TContext>(options: 
{
  mutation?: UseMutationOptions<CfrTranscodingStartCfrTranscodingJobMutationResponse, ResponseErrorConfig<Error>, {fragmentId: CfrTranscodingStartCfrTranscodingJobPathParams["fragmentId"], data?: CfrTranscodingStartCfrTranscodingJobMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<CfrTranscodingStartCfrTranscodingJobMutationRequest>> & { client?: typeof fetch },
}
 = {}) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? cfrTranscodingStartCfrTranscodingJobMutationKey()

  return useMutation<CfrTranscodingStartCfrTranscodingJobMutationResponse, ResponseErrorConfig<Error>, {fragmentId: CfrTranscodingStartCfrTranscodingJobPathParams["fragmentId"], data?: CfrTranscodingStartCfrTranscodingJobMutationRequest}, TContext>({
    mutationFn: async({ fragmentId, data }) => {
      return cfrTranscodingStartCfrTranscodingJob(fragmentId, data, config)
    },
    mutationKey,
    ...mutationOptions
  }, queryClient)
}